<template>
	<div>
		<Header :mode="mode"></Header>
		<PageHeading mode="alert"></PageHeading>
		<PrimaryMenu></PrimaryMenu>
		<LibraryBook></LibraryBook>
		<ScrollTop></ScrollTop>
		<Footer mode="white"></Footer>
	</div>
</template>

<script>
import Header from "../components/Header";
import PrimaryMenu from "../components/PrimaryMenu";
import LibraryBook from "../components/LibraryBook";
import PageHeading from "../components/PageHeading";
import ScrollTop from "../components/ScrollTop";
import Footer from "../components/Footer";
import store from "../store/";

export default {
	name: "LibraryBookPage",
	store,
	components: {
		Header,
		PrimaryMenu,
		PageHeading,
		LibraryBook,
		ScrollTop,
		Footer,
	},
	created() {
		document.title = this.$route.meta.title;
	},
	computed: {
        book() {
			return this.$store.state["LibraryBook"].book;
		},
		mode() {
			if (!this.book.cover_display) {
				return 'light-grey'
			}
			else return 'grey'
		}
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/LibraryBookPage.vue